import React from 'react';

import { Spaced, TitleSpaced } from '../common/container/Container.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { City as CityCell } from '../common/container/Cell.jsx';

class Cities extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true
        };
    }

    componentDidMount() {
        const component = this;
        component.request = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.cities.get(),
            null,
            function (responseData) {
                component.request = null;

                responseData.Data.forEach(function (d) {
                    if (d.Image) {
                        d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, 375, 300, 'c_fill');
                    }
                });
                component.setState({
                    data: responseData.Data,
                    loading: false
                });
            },
            function (jqXHR, textStatus) {
                component.request = null;

                component.setState({
                    loading: false
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    componentWillUnmount() {
        if (this.request) {
            this.request.abort();
            this.request = null;
        }
    }

    render() {
        let cities;
        if (this.state.data) {
            cities = this.state.data.map((d) =>
                <CityCell key={d.CityId} d={d} slider={true} />
            );
        }
        return (
            <React.Fragment>
                <div className="section spacer--nsb">
                    <div className="container">
                        <TitleSpaced>
                            <h2>Browse Cities</h2>
                        </TitleSpaced>
                    </div>
                </div>

                <section className="section">
                    <Spaced>
                        <div className="container--spaced__row">
                            {cities}
                        </div>
                        {
                            this.state.loading &&
                            <LoadingIndicator />
                        }
                    </Spaced>
                </section>
            </React.Fragment>
        );
    }
}

export default Cities;